import React, { useState, useEffect } from 'react';
import { TESTIMONIALS, SITE } from '../data/mock';
import { Quote, ChevronLeft, ChevronRight } from 'lucide-react';

const TestimonialsSection = () => {
  const [page, setPage] = useState(0);
  const perPage = 3;
  const totalPages = Math.ceil(TESTIMONIALS.length / perPage);

  useEffect(() => {
    const t = setInterval(() => setPage((p) => (p + 1) % totalPages), 7000);
    return () => clearInterval(t);
  }, [totalPages]);

  const start = page * perPage;
  const visible = TESTIMONIALS.slice(start, start + perPage);
  // pad with first ones if last page has fewer
  while (visible.length < perPage) visible.push(TESTIMONIALS[visible.length]);

  return (
    <section className="py-20 md:py-24 bg-slate-50">
      <div className="max-w-[1200px] mx-auto px-6">
        <div className="text-center mb-12">
          <p className="uppercase text-sm tracking-[0.25em] text-slate-500 mb-3">Our Clients Testimonials</p>
          <h2 className="heading-display text-4xl md:text-5xl font-bold text-slate-900">What They Say</h2>
          <div className="mx-auto mt-4 flex items-center justify-center gap-1">
            <span className="w-8 h-0.5 bg-[#F97559]" />
            <span className="w-2 h-2 rounded-full bg-[#F97559]" />
            <span className="w-8 h-0.5 bg-[#F97559]" />
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-7">
          {visible.map((t, i) => (
            <div key={`${page}-${i}`} className="bg-white rounded-sm p-8 shadow-sm card-lift relative fade-up">
              <Quote className="absolute top-4 right-4 text-slate-100" size={48} />
              <p className="text-slate-600 leading-7 text-[14.5px] relative z-10">&ldquo;{t.text}&rdquo;</p>
              <div className="mt-7 flex items-center gap-4">
                <div className="w-14 h-14 rounded-full bg-[#F97559] grid place-items-center text-white font-bold text-lg overflow-hidden">
                  <img src={SITE.logo} alt={t.name} className="w-10 h-10 object-contain" />
                </div>
                <div>
                  <p className="heading-display font-bold text-slate-900">{t.name}</p>
                  <p className="text-sm text-slate-500">{t.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className="flex justify-center items-center gap-3 mt-10">
          <button onClick={() => setPage((p) => (p - 1 + totalPages) % totalPages)} className="w-11 h-11 rounded-full border border-slate-300 hover:bg-[#F97559] hover:text-white hover:border-[#F97559] grid place-items-center text-slate-600 transition-colors" aria-label="Prev"><ChevronLeft /></button>
          {Array.from({ length: totalPages }).map((_, i) => (
            <button key={i} onClick={() => setPage(i)} className={`h-2 rounded-full transition-all ${i === page ? 'bg-[#F97559] w-8' : 'bg-slate-300 w-2 hover:bg-slate-400'}`} aria-label={`Page ${i+1}`} />
          ))}
          <button onClick={() => setPage((p) => (p + 1) % totalPages)} className="w-11 h-11 rounded-full border border-slate-300 hover:bg-[#F97559] hover:text-white hover:border-[#F97559] grid place-items-center text-slate-600 transition-colors" aria-label="Next"><ChevronRight /></button>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
